export default {
  chatIconAriaLabel: '{{teamName}} logo',
};
